// extracted by mini-css-extract-plugin
export default {"aigc_message":"AIGCMessage_aigc_message__iqa8u","aigc_message_text":"AIGCMessage_aigc_message_text__Djj3A"};